<div class="whatsNew">
  <a
    class="whatsNew-notifications"
    href="#beamerTrigger"
    target="_blank"
    rel="noreferrer noopener"
    uiLogEvent
    analyticsKey="headerWhatsNewClick"
  >
    <img
      [src]="'sidebar-icons/whats_new.svg' | assetsPath | async"
      [class.desktop-icon]="!(isMobile$ | async)"
      alt=""
      width="21"
      height="21"
    />
    <span *ngIf="!(isMobile$ | async)" class="whats-new-label" data-lokalise data-key="txt_whats_new_label"></span>
  </a>
</div>
